<div class="heading">
    <i class="fas fa-exclamation-circle"></i>
    <span>Service temporarily unavailable</span>
</div>

<div class="issueDesc">Sorry, we can't take your problem report online right now, but we'll be happy to help if you contact us using one of these other options:</div>

<div class="containers">
    <div class="infoContainer left">
        <div class="containerMargin">
            <!-- <div class="containerIcon"><i class="far fa-envelope"></i></div> -->
            <div class="containerIcon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                    <path d="M0 128C0 92.65 28.65 64 64 64H448C483.3 64 512 92.65 512 128V384C512 419.3 483.3 448 448 448H64C28.65 448 0 419.3 0 384V128zM32 128V167.9L227.6 311.3C244.5 323.7 267.5 323.7 284.4 311.3L480 167.9V128C480 110.3 465.7 96 448 96H63.1C46.33 96 31.1 110.3 31.1 128H32zM32 207.6V384C32 401.7 46.33 416 64 416H448C465.7 416 480 401.7 480 384V207.6L303.3 337.1C275.1 357.8 236.9 357.8 208.7 337.1L32 207.6z"/>
                </svg>
            </div>
            <h3 class="containerInfo">Email <span class="emailAddress"><a href="mailto:infoweb@dnv.org?subject=Report a Problem report">infoweb@dnv.org</a></span></h3>
            <div class="containerInstructions">
                Include in your email:
                <div class="inclusionList">
                    <ul>
                        <li>A description of the problem</li>
                        <li>The location of the problem</li>
                        <li>Your contact details (optional)</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="infoContainer right">
        <div class="containerMargin">
            <!-- <div class="containerIcon"><i class="fas fa-phone"></i></div> -->
            <div class="containerIcon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                    <path d="M1.153 382.4l21.8 94.47C27.72 497.6 45.89 512 67.12 512C312.4 512 512 312.4 512 67.12c0-21.22-14.47-39.34-35.17-44.06l-94.39-21.91c-21.2-4.891-43.09 6.125-51.81 26.22L287 129.2c-7.984 18.69-2.828 39.92 12.84 52.84l40.52 33.19c-28.7 52.73-72.56 96.59-125.3 125.3L181.9 300C169.4 284.6 147.7 279.3 129.2 286.1L27.4 330.6c-.0156 .0313 .0156 0 0 0C7.317 339.3-3.738 361.1 1.153 382.4zM32.34 375.2c-1.438-6.25 1.813-12.66 7.719-15.22l101.6-43.56c5.344-2.219 11.8-.7188 15.5 3.844l41.39 50.5c4.703 5.75 12.8 7.531 19.44 4.219c67.83-33.38 123.6-89.09 156.9-156.9c3.281-6.672 1.531-14.72-4.219-19.44L320.2 157.3c-4.578-3.781-6.109-10.03-3.75-15.55l43.58-101.7c2.141-4.938 7.016-8.031 12.25-8.031c.9844 0 1.984 .1094 2.984 .3438l94.41 21.91c6.109 1.391 10.34 6.688 10.34 12.88c0 227.7-185.2 412.9-412.9 412.9c-6.141 0-11.61-4.344-12.98-10.31L32.34 375.2z"/>
                </svg>
            </div>
            <h3 class="containerInfo">Call us</h3>
            <div class="containerInstructions">
                <div class="contactDetail">
                    <div class="dateTime">Weekdays <span>(8:00am - 4:30pm)</span></div>
                    <div class="phoneNumber"><a href="tel:+16049902311">604-990-2311</a></div>
                </div>

                <div class="contactDetail">
                    <div class="dateTime">Weekends, Holidays and After Hours</div>
                    <div class="phoneNumber"><a href="tel:+16049903666">604-990-3666</a></div>
                </div>
            </div>
        </div>
    </div>
</div>